module.exports = __webpack_public_path__ + "img/album21_15.02ff0378.jpg";